import React, { useState, useEffect, useRef } from 'react';
import { View, Text, Pressable, StyleSheet, Icon } from '../lib/react-native-compat';
import SummaryOld from './summary';
import SummaryInventory from './summaryInventory';
import SummaryJob from './summaryJob';
import TimeMaterialsSummary from './timeMaterialsReport';
import TimeMaterialsReportOld from './timeMaterialsReportOld';
import { useAtom } from 'jotai';
import { selectedTeamAtom } from '../store/company';

const SummaryDashboard = () => {
    const [selectedTeam] = useAtom(selectedTeamAtom);
    const isPickettTeam = selectedTeam === 'PICKETT' || selectedTeam === 'Pickett';
    const [activeTab, setActiveTab] = useState('Summary');
    const tabs = isPickettTeam
        ? ['Summary', 'Job', 'Inventory Summary', 'T&M Summary', 'T&M Summary - Old']
        : ['Summary', 'Job', 'T&M Summary', 'T&M Summary - Old'];

    useEffect(() => {
        if (!isPickettTeam && activeTab === 'Inventory Summary') {
            setActiveTab('Summary');
        }
    }, [isPickettTeam, activeTab]);
    const [pageWidth, setPageWidth] = useState(window.innerWidth);
    const childRef = useRef();

    const callChildExcel = () => {
        console.log('download step 1', childRef.current);
        if (childRef.current) {
            childRef.current.createExcel();
        }
    };

    const callChildLoadAll = () => {
        if (childRef.current) {
            childRef.current.setLoadAll();
        }
    };

    const callChildExportToTemplate = () => {
        if (childRef.current && childRef.current.exportToExcel) {
            childRef.current.exportToExcel();
        }
    };


    useEffect(() => {
        const handleResize = () => {
            setPageWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <View style={{ minHeight: '100vh', backgroundColor: '#F5F7FA' }}>
            <View style={[styles.container, { flex: 1, minWidth: pageWidth - 300, flexGrow: 0, maxHeight: 65}]}>
                <View style={{ flexDirection: 'row', gap: 20, marginLeft: 10}}>
                    {tabs.map((tab) => (
                        <Pressable
                            key={tab}
                            onPress={() => setActiveTab(tab)}
                            style={[
                                styles.tabItem,
                                {
                                    paddingVertical: 12,
                                    paddingHorizontal: 16,
                                    borderBottom: activeTab === tab ? '2px solid #2563eb' : '2px solid transparent',
                                    justifyContent: 'center',
                                }
                            ]}
                        >
                            <Text style={[styles.tabText, activeTab === tab && styles.activeText]}>
                                {tab}
                            </Text>
                        </Pressable>
                    ))}
                </View>
                <View style={{ flexDirection: 'row', padding: 5, gap: 10 }}>

                    <Pressable
                        style={{
                            alignItems: 'center',
                            backgroundColor: '#f8fafc',
                            padding: 12,
                            paddingHorizontal: 16,
                            borderRadius: 6,
                            flexDirection: 'row',
                            border: '1px solid #cbd5e1',
                            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                            marginLeft: 20
                        }}
                        onPress={() => {
                            callChildExportToTemplate()
                        }}
                    >
                        <Text style={{ marginRight: 10, color: '#334155', fontWeight: '500', fontSize: 14 }}>Download</Text>
                        <Icon
                            name="↓"
                            size={18}
                            color="#334155"
                        />
                    </Pressable>
                    {/* <Pressable
                        style={{
                            alignItems: 'center',
                            backgroundColor: '#4CAF50',
                            padding: 12,
                            paddingHorizontal: 16,
                            borderRadius: 6,
                            flexDirection: 'row',
                            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
                        }}
                        onPress={() => {
                            callChildExportToTemplate()
                        }}
                    >
                        <Text style={{ marginRight: 10, color: 'white', fontWeight: '500', fontSize: 14 }}>Export to Template</Text>
                        <Icon
                            name="↓"
                            size={18}
                            color="white"
                        />
                    </Pressable> */}
                    <Pressable
                        style={{
                            alignItems: 'center',
                            backgroundColor: '#f8fafc',
                            padding: 12,
                            paddingHorizontal: 16,
                            borderRadius: 6,
                            flexDirection: 'row',
                            border: '1px solid #cbd5e1',
                            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
                        }}
                        onPress={() => {
                            callChildLoadAll()
                        }}
                    >
                        <Text style={{ marginRight: 10, color: '#334155', fontWeight: '500', fontSize: 14 }}>Load All Teams</Text>
                    </Pressable>


                </View>
            </View>
            {activeTab === 'Summary' ? (
                <SummaryOld refSubNav={childRef} job="seth" />
            ) : activeTab === 'Job' ? (
                <SummaryJob refSubNav={childRef} />
            ) : activeTab === 'Inventory Summary' ? (
                <SummaryInventory refSubNav={childRef} job="seth" />
            ) : activeTab === 'T&M Summary - Old' ? (
                <TimeMaterialsReportOld refSubNav={childRef} />
            ) : (
                <TimeMaterialsSummary refSubNav={childRef} />
            )}
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        backgroundColor: '#fff',
        paddingLeft: 20,
        paddingTop: 8,
        borderBottom: '1px solid #e2e8f0',
        flexDirection: 'row'
    },
    tabItem: {
        paddingVertical: 12,
        paddingHorizontal: 16,
    },
    activeTab: {
        borderBottomColor: '#2563eb',
    },
    tabText: {
        fontSize: 14,
        color: '#6b7280',
        fontWeight: '400',
    },
    activeText: {
        color: '#2563eb',
        fontWeight: '500',
    },
    content: {
        padding: 20,
    },
    contentText: {
        fontSize: 16,
    },
});

export default SummaryDashboard;

